import { LinkButton } from '@components/LinkButton'
import {
	Box,
	Callout,
	IconSolidSparkles,
	Stack,
	Text,
} from '@highlight-run/ui/components'
import { useProjectId } from '@hooks/useProjectId'

export const CompleteSetup = () => {
	const { projectId } = useProjectId()

	return (
		<Box margin="auto" style={{ maxWidth: 300 }}>
			<Callout
				title="Finish installing LogReplay"
				icon={IconSolidSparkles}
			>
				<Box display="flex" flexDirection="column" gap="16">
					<Text color="moderate">
						Connect the backend SDK, then confirm error monitoring
						settings for this project.
					</Text>
					<Stack gap="6" direction="row">
						<LinkButton
							to={`/${projectId}/settings/errors`}
							trackingId="finish-setup-errors"
						>
							Error settings
						</LinkButton>
						<LinkButton
							to="/demo/errors"
							trackingId="view-demo-error"
							kind="secondary"
							emphasis="low"
						>
							Demo errors
						</LinkButton>
					</Stack>
				</Box>
			</Callout>
		</Box>
	)
}
